import { ArrowRight } from "lucide-react";

const PORTRAITS = [
  { src: "/assets/hero_companion.jpg", name: "Aria", pos: "50% 17%" },
  { src: "/assets/product_companion.jpg", name: "Aiden", pos: "50% 20%" },
  { src: "/assets/char_nova.jpg", name: "Nova", pos: "50% 22%" },
  { src: "/assets/char_selene.jpg", name: "Selene", pos: "55% 19%" },
  { src: "/assets/char_iris.jpg", name: "Iris", pos: "50% 26%" },
  { src: "/assets/demo_still.jpg", name: "Aria", pos: "50% 25%" },
];

export default function CompanionStrip() {
  const row = [...PORTRAITS, ...PORTRAITS];
  return (
    <div className="w-full pt-[80px]">
      <a href="/#demo" data-testid="companion-strip" className="group block w-full">
        <div className="mx-auto flex w-full max-w-7xl items-end justify-between gap-4 px-6 lg:px-10">
        <div>
          <p className="font-display text-[10px] font-semibold uppercase tracking-[0.3em] text-cyan-300/90">
            AI Companion Concepts
          </p>
          <p className="mt-1.5 text-[10px] uppercase tracking-[0.22em] text-[#B9A7FF]">
            Photorealistic digital characters · Experience in development
          </p>
        </div>
        <span className="flex shrink-0 items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.15em] text-cyan-200/80 transition-colors duration-300 group-hover:text-cyan-100 sm:text-[11px]">
          Explore AI Companions
          <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
      <div className="marquee-mask mt-3 overflow-hidden">
        <div className="animate-companion-strip flex w-max gap-3 pr-3">
          {row.map((p, i) => (
            <div
              key={i}
              className="relative h-[130px] w-[150px] shrink-0 overflow-hidden rounded-xl border border-white/10 bg-black sm:h-[140px] sm:w-[160px] lg:h-[140px] lg:w-[160px]"
            >
              <img
                src={p.src}
                alt={`${p.name} — photorealistic AI companion, concept visual`}
                loading="lazy"
                style={{ objectPosition: p.pos }}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
            </div>
          ))}
        </div>
      </div>
      </a>
    </div>
  );
}
